module.exports = __webpack_public_path__ + "static/antd-table-fixed-columns-1d64afb6bb90a89845b742989b31e73c.png";